export const appearanceColorFields = [
  { key: 'backgroundColor', label: 'Color de fondo', defaultColor: '#FFFFFF' },
  { key: 'contentBackgroundColor', label: 'Area de contenido: color de fondo', defaultColor: '#FFFFFF' },
  { key: 'headerBackgroundColor', label: 'Cabecera: color de fondo', defaultColor: '#D2D2D2' },
  { key: 'footerBackgroundColor', label: 'Footer: color de fondo', defaultColor: '#D2D2D2' },
]
